<template>
    <modal :show="show" showLarge>
        <div slot="modalHeader">
          <modal-header :closeModal="customClose">Assets</modal-header>
        </div>
        <spinner-icon v-if="loading" />
        <notifications :messages="notifications" v-if="showAssetNotification && notifications && notifications.length > 0"/>
        <div class="assetUpload">
          <upload-file icon="upload" ctaText="Upload New Asset" @input="onUploadAsset" multipleFiles />
        </div>
        <hr />

        <search-box v-model="search" name="assets..." />
        <hr />
        <asset-table :tableData="filteredAssets" @deleteFile="onDeleteAsset" @selectFile="selectImage" v-bind:confirmId="confirmId"/>
        <div slot="modalFooter">
          <modal-footer cancelText="Close" :closeModal="customClose" hideConfirmText />
        </div>
    </modal>
</template>

<script>
import Modal from '@/components/Modal/modal'
import ModalHeader from '@/components/Modal/modal-header'
import ModalFooter from '@/components/Modal/modal-footer'
import ButtonCta from '@/components/Button/button'
import FormGroup from '@/components/Form/FormGroup/form-group'
import Field from '@/components/Form/Field/field'
import CreativeTable from '@/components/CreativeTable/creative-table'
import AssetTable from '@/components/AssetTable/asset-table'
import UploadFile from '@/components/UploadFile/upload-file'
import SearchBox from '@/components/SearchBox/searchbox'
import SpinnerIcon from '@/components/SpinnerIcon/spinner'
import Notifications from '@/components/Notifications/notifications'

import {modalMixin} from '@/mixins/modalMixin'
import {assetMixin} from '@/mixins/assetMixin'
import {creativeMixin} from '@/mixins/creativeMixin'
import {notificationMixin} from '@/mixins/notificationMixin'

export default {
  name: 'modal_asset_library',
  mixins: [modalMixin, assetMixin, creativeMixin, notificationMixin],
  components: {
    Modal,
    ModalHeader,
    ModalFooter,
    ButtonCta,
    FormGroup,
    Field,
    CreativeTable,
    AssetTable,
    UploadFile,
    SearchBox,
    SpinnerIcon,
    Notifications
  },
  props: {
    show: Boolean,
    confirmId: String,
    field: String,
    fieldType: String,
    forceReloadAssetsLibraryData: {type: Boolean, default: false}
  },
  data: () => ({
    errors: {
      name: ''
    },
    search: '',
    showAssetNotification: false,
    dataLoaded: ''
  }),
  created () {},
  computed: {
    assetId () {
      return this.$route.params.id
    },
    isEditMode () {
      return this.confirmId
    },
    filteredAssets () {
      return this.assets.filter(asset => {
        return asset.file.toLowerCase().includes(this.search.toLowerCase()) || asset.width.toLowerCase().includes(this.search.toLowerCase()) || asset.height.toLowerCase().includes(this.search.toLowerCase())
      })
    }
  },
  watch: {
    show: 'callAssets',
    /**
     * When the parent component triggers a change for the prop {forceReloadAssetsLibraryData}, force the value for
     * dataLoaded to empty string to force the modal to reload the assets library due an update or change.
     */
    forceReloadAssetsLibraryData: function () {
      this.dataLoaded = ''
    }
  },
  methods: {
    closeVideos () {
      // var video = document.getElementById("myVideoPlayer");
      var elems = document.body.getElementsByTagName('video')
      // elems.forEach(this.closeVideo())
      for (let item of elems) {
        item.pause()
      }
    },
    customClose () {
      this.closeVideos()
      this.close()
    },
    callAssets () {
      if (this.show) {
        if ((typeof this.fieldType === 'undefined') && this.dataLoaded === 'all') {
          return
        }
        if (this.dataLoaded === 'video' && this.fieldType === 'video') {
          return
        }
        if (this.dataLoaded === 'image' && this.fieldType === 'image') {
          return
        }
        this.startLoading()
        switch (this.fieldType) {
          case 'video':
            this.getVideoAssets(this.assetId).then(() => {
              // could remove spinner if we had one in this section
              console.log('Loading Video asset box')
              this.finishLoading()
              this.dataLoaded = 'video'
            })
            break
          case 'image':
            this.getImageAssets(this.assetId).then(() => {
              // could remove spinner if we had one in this section
              console.log('Loading Image asset box')
              this.finishLoading()
              this.dataLoaded = 'image'
            })
            break
          default:
            this.getAssets(this.assetId).then(() => {
              // could remove spinner if we had one in this section
              console.log('Loading default asset box')
              this.finishLoading()
              this.dataLoaded = 'all'
            })
            break
        }
      }
    },
    selectImage (image) {
      this.$emit('selectImage', this.confirmId, this.field, image, this.fieldType)
      this.customClose()
    },
    onDeleteAsset (filename) {
      this.startLoading()
      const data = {
        id: this.assetId,
        fileName: filename
      }
      this.deleteAsset(data).then((response) => {
        switch (this.fieldType) {
          case 'video':
            this.getVideoAssets(this.assetId).then(() => {
              this.finishLoading()
              this.showAssetNotification = true
              this.dataLoaded = 'video'
              this.addNotification('success', response.reason)
            })
            break
          case 'image':
            this.getImageAssets(this.assetId).then(() => {
              this.finishLoading()
              this.showAssetNotification = true
              this.dataLoaded = 'image'
              this.addNotification('success', response.reason)
            })
            break
          default:
            this.getAssets(this.assetId).then(() => {
              this.finishLoading()
              this.showAssetNotification = true
              this.dataLoaded = 'all'
              this.addNotification('success', response.reason)
            })
            break
        }
      }, error => {
        this.finishLoading()
        this.addNotification('danger', error)
      })
    },
    onUploadAsset (e) {
      this.startLoading()
      const files = e.target.files || e.dataTransfer.files
      const formData = new FormData()
      Object.keys(files).forEach((key) => {
        formData.append('file' + key, files[key])
      })
      const data = {
        id: this.assetId,
        file: formData
      }
      this.uploadAssets(data).then((response) => {
        switch (this.fieldType) {
          case 'video':
            this.getVideoAssets(this.assetId).then(() => {
              this.finishLoading()
              this.showAssetNotification = true
              this.dataLoaded = 'video'
              this.addNotification('success', response.status)
            })
            break
          case 'image':
            this.getImageAssets(this.assetId).then(() => {
              this.finishLoading()
              this.showAssetNotification = true
              this.dataLoaded = 'image'
              this.addNotification('success', response.status)
            })
            break
          default:
            this.getAssets(this.assetId).then(() => {
              this.finishLoading()
              this.showAssetNotification = true
              this.dataLoaded = 'all'
              this.addNotification('success', response.status)
            })
            break
        }
      }, error => {
        this.finishLoading()
        this.addNotification('danger', error)
      })
    }
  }
}
</script>

<style lang="scss">
  .asset {
    overflow: hidden;
    position: relative;
    margin-bottom: 20px;
    border-radius: 3px;
    border: solid #e1e1e1 1px;

    .asset__img {
      background-color: #ccc;
      background-image: linear-gradient(45deg, rgba(0, 0, 0, .2) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, .2) 75%, rgba(0, 0, 0, .2)), linear-gradient(45deg, rgba(0, 0, 0, .2) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, .2) 75%, rgba(0, 0, 0, .2));
      background-size: 10px 10px;
      background-position: 0 0, 5px 5px;
      padding: 5px;
      height: 170px;
      img {
        width: 100%;
        height: 100%;
        object-fit: scale-down;
      }
      position: relative;
      overflow: hidden;
    }

    .asset__trash {
      position: absolute;
      top: 10px;
      right: 4px;
      background-color: #000863;
      width: 28px;
      height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      .fa {
        font-size: 20px;
        color: #DDD;
      }
    }

    .asset__video {
      position: absolute;
      top: 10px;
      left: 4px;
      background-color: #000863;
      width: 28px;
      height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      .fa {
        font-size: 20px;
        color: #DDD;
      }
    }

    .asset__info {
      padding: 5px;
      text-align: center;
    }

    .asset__info_table {
      display: table;
      width: 100%;
      height: 100%;

      span {
        display: table-cell;
        vertical-align: middle;
        text-align: center;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Modal/assets/modal-asset-library.vue